import { render, staticRenderFns } from "./uploadnew.vue?vue&type=template&id=37e2fa7a&scoped=true&"
import script from "./uploadnew.vue?vue&type=script&lang=js&"
export * from "./uploadnew.vue?vue&type=script&lang=js&"
import style0 from "./uploadnew.vue?vue&type=style&index=0&id=37e2fa7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e2fa7a",
  null
  
)

export default component.exports